import { atom } from 'recoil';

export const refreshJobDTOAtom = atom<object>({
    key: 'refreshJobDTOAtom',
    default: {}
});
